import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { H3, SM, SearchBox } from '@foodsby/nutrient-v3'
import scriptLoader from 'react-async-script-loader'
import useOutsideClick from '../../util/click'
import { MAPS_SCRIPT_URL } from '../location-search/LocationSearchBox'
import { connect } from 'react-redux'
import { getDayName } from '../../util/dateUtils'
import { search } from '../../redux/modules/locationSearch'
import { space, flexbox } from 'styled-system'

const SearchModal = ({ search }) => {
  return (
    <>
      <SearchBox className="-search" linkText="Change" search={search} />
    </>
  )
}

const matchStateToProps = state => {
  const { loading, error } = state.locationSearch

  return {
    loading,
    error,
  }
}

const matchDispatchToProps = { search }

const SearchModalWithScripts = scriptLoader(MAPS_SCRIPT_URL)(
  connect(matchStateToProps, matchDispatchToProps)(SearchModal),
)

export const YourLocation = ({ name, selectedDate }) => {
  // State used for displaying location input
  const [isEditingLocation, setIsEditingLocation] = useState(false)
  const [curRef, setCurRef] = useState({ current: undefined })
  const ref = useCallback(node => {
    setCurRef({ current: node })
  }, [])

  useOutsideClick(curRef, () => {
    setIsEditingLocation(false)
  })

  return (
    <Flex className="locationContainer" mb={4}>
      <H3>{getDayName(selectedDate)}</H3>
      <Component className="NutrientV3">
        {!isEditingLocation ? (
          <Address>
            <i className="icon-location secondary" />
            <SM
              className="-locationName"
              onClick={() => {
                setIsEditingLocation(true)
              }}
            >
              {name}
            </SM>
          </Address>
        ) : (
          <div ref={ref}>
            <SearchModalWithScripts />
          </div>
        )}
      </Component>
    </Flex>
  )
}

YourLocation.defaultProps = {
  address: {},
}
const Flex = styled.div`
  ${flexbox};
  ${space};

  align-itmes: center;
  display: flex;
  justify-content: space-between;

  // TODO: pull this media query in as a var from Nutrient
  @media screen and (min-width: 320px) and (max-width: 640px) {
    flex-direction: column-reverse;
  }
`

const Component = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
  z-index: 2;

  @media screen and (min-width: 320px) and (max-width: 640px) {
    margin-bottom: 20px;
    width: 100%;
  }
`

const Address = styled.div`
  align-self: flex-end;
  color: #59969b;

  & .-locationName {
    text-decoration: underline;
    text-align: center;
    color: #59969b;

    &:hover {
      cursor: pointer;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 640px) {
    align-self: center;
  }
`

export default Component
